import { associatedItemsRenderer, numericSorter } from '@lib/generic.utils'
import { agStartDateCol } from '@/ag-grid/ag-columns'

export default {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'TextEditor',
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/title-lists/${params.data.id}`
              }
            }
          },

          {
            headerName: 'Titles',
            field: 'publications_count',
            comparator: numericSorter,
            tooltipValueGetter: params => associatedItemsRenderer(params.value, 'title', 'titles')
          },

          agStartDateCol({
            headerName: 'Valid from',
            field: 'valid_from',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          agStartDateCol({
            headerName: 'Valid to',
            field: 'valid_to',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          {
            headerName: 'Actions',
            type: 'centerAligned',
            maxWidth: 85,
            cellRendererFramework: 'ActionsCol',
            cellRendererParams: params => ({
              popupActions: [
                { name: 'duplicate', label: 'Duplicate' },
                { name: 'delete', label: 'Delete', textColorClass: 'text-danger-1' }
              ],
              onPopupAction: event => {
                this[event](params.data)
              }
            })
          }
        ]
      }
    }
  }
}
